import React, { useState } from "react";
import PropTypes from "prop-types";

import PhotoUploadSectionContainer from "./PhotoUploadSectionContainer";
import PhotoUploadToolbar from "../PhotoUploadToolbar";
import PhotoUploadDropzone from "../PhotoUploadDropzone";
import Edit from "../PhotoUpload/Edit";
import PhotoUploadFooter from "../PhotoUploadFooter";
import Messages from "core/Messages";
import PhotoUploadDuplicateFilename from "../PhotoUploadDuplicateFilename";

import {
    usePhotoUploadsInDropzone,
    useFailedPhotoUploads,
    useUploadsCurrentlyProcessing
} from "./hooks";
import usePhotoUploadDropzone from "../PhotoUploadDropzone/usePhotoUploadDropzone";

const PhotoUploadLayout = ({ masthead }) => {
    const [showSubmissionError, setShowSubmissionError] = useState(false);

    const PhotoUploadMasthead = masthead;

    const {
        uploadCount: uploadsInDropzoneCount,
        uploadIds: uploadsInDropzoneIds
    } = usePhotoUploadsInDropzone();
    const { allFailedUploadsCount, allUploadErrors } = useFailedPhotoUploads();
    const { count: currentlyProcessingCount } = useUploadsCurrentlyProcessing();
    const { dropzoneProps } = usePhotoUploadDropzone();

    return (
        <>
            <PhotoUploadSectionContainer>
                <PhotoUploadMasthead
                    uploadsInDropzoneCount={uploadsInDropzoneCount}
                />
                <PhotoUploadToolbar
                    uploadsInDropzoneCount={uploadsInDropzoneCount}
                />
                {showSubmissionError && (
                    <Messages
                        styleType="solid"
                        infoType="error"
                        handleDismissClick={() => {}}
                    >
                        Sorry, something went wrong. Please try again.
                    </Messages>
                )}
                <PhotoUploadDropzone />
                <Edit uploadsInDropzoneIds={uploadsInDropzoneIds} />
            </PhotoUploadSectionContainer>
            <PhotoUploadFooter
                setShowSubmissionError={setShowSubmissionError}
                uploadCount={uploadsInDropzoneCount}
                failedUploadCount={allFailedUploadsCount}
                currentlyProcessingCount={currentlyProcessingCount}
                initialMaximumFiles={
                    dropzoneProps && dropzoneProps.initialMaximumFiles
                }
                allUploadErrors={allUploadErrors}
            />

            <PhotoUploadDuplicateFilename />
        </>
    );
};

PhotoUploadLayout.propTypes = {
    masthead: PropTypes.func.isRequired
};

export default PhotoUploadLayout;
